import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Tablet = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 17"
      {...rest}
      fill={fill}
    >
      <path d="M12.666 13.383H3.333a.333.333 0 1 1 0-.666h9.333a.333.333 0 1 1 0 .666Z" />
      <path d="M13 16.05H3a1.669 1.669 0 0 1-1.666-1.667v-12A1.669 1.669 0 0 1 3.001.717h10a1.668 1.668 0 0 1 1.666 1.666v12A1.668 1.668 0 0 1 13 16.049ZM3 1.382a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-12a1 1 0 0 0-1-1H3Z" />
    </svg>
  );
};

Tablet.category = 'product-category';

Tablet.displayName = 'Tablet';
